<template>
    <el-dialog title="Auto工作台" :visible.sync="visibleSync" width="96%"
        custom-class="auto-workbench-dialog" :close-on-click-modal="false" append-to-body>
        <el-tabs v-model="currentTab" type="card" class="auto-workbench-tabs">
            <el-tab-pane name="msku" lazy>
                <span slot="label"><i class="el-icon-document-add"></i> MSKU记录</span>
                <auto-msku-task-dialog :visible="visible" :embedded="true"
                    :active="visible && currentTab === 'msku'" />
            </el-tab-pane>
            <!--
            首期暂不上线：移入/移出任务和操作日志不属于 MSKU 生成、轮询与配对主流程。
            <el-tab-pane name="tasks" lazy>
                <span slot="label"><i class="el-icon-s-operation"></i> 任务面板</span>
                <task-panel-dialog :visible="visible" :embedded="true" :active="visible && currentTab === 'tasks'"
                    mode="all" :shop="shop" @loaded="onTasksLoaded" />
            </el-tab-pane>
            <el-tab-pane name="logs" lazy>
                <span slot="label"><i class="el-icon-tickets"></i> 操作日志</span>
                <operation-log-panel :active="visible && currentTab === 'logs'" :parent="parent" :shop="shop"
                    :shop-options="shopOptions" />
            </el-tab-pane>
            -->
        </el-tabs>
    </el-dialog>
</template>

<script>
import AutoMskuTaskDialog from './AutoMskuTaskDialog.vue';
import TaskPanelDialog from './TaskPanelDialog.vue';
import OperationLogPanel from './OperationLogPanel.vue';

export default {
    name: 'AutoWorkbenchDialog',
    components: { AutoMskuTaskDialog, TaskPanelDialog, OperationLogPanel },
    props: {
        visible: { type: Boolean, default: false },
        activeTab: { type: String, default: 'msku' },
        parent: { type: String, default: '' },
        shop: { type: String, default: '' },
        shopOptions: { type: Array, default: () => [] },
    },
    data() {
        return {
            currentTab: 'msku',
        };
    },
    computed: {
        visibleSync: {
            get() { return this.visible; },
            set(value) { this.$emit('update:visible', value); },
        },
    },
    watch: {
        activeTab: {
            immediate: true,
            handler(value) {
                this.currentTab = this.normalizeTab(value);
            },
        },
        visible(value) {
            if (value) this.currentTab = this.normalizeTab(this.activeTab);
        },
    },
    methods: {
        onTasksLoaded(rows) {
            this.$emit('tasks-loaded', rows || []);
        },
        normalizeTab() {
            // 首期只开放 MSKU 记录页；保留 activeTab 调用入口，后续恢复页签时无需改调用方。
            return 'msku';
        },
    },
};
</script>

<style scoped>
.auto-workbench-tabs {
    min-height: 560px;
}

.auto-workbench-tabs /deep/ .el-tabs__content {
    overflow: visible;
}
</style>

<!-- append-to-body 后不受 scoped 选择器影响，主工作台在原位置基础上下移 50px。 -->
<style>
.auto-workbench-dialog {
    margin-top: max(0px, calc(15vh - 100px)) !important;
}
</style>
